import { useQueryClient } from '@tanstack/react-query';

import {
	CC_CONFIG_TYPES,
	CC_DATES,
	CC_MAVENIR_DATES,
	CC_NODE_TYPES,
	CC_NODES,
	CC_RELEASE_VERSIONS,
	CC_SITE_IDS,
	CC_TECHNOLOGIES,
	CC_VENDORS,
	CONSISTENCY_VENDORS,
	HISTORY_CHECK_VENDOR,
	MAVENIR_CONFIG_DATES,
	MAVENIR_CONFIG_GNB_IDS,
	MAVENIR_CONFIG_IDS,
	MAVENIR_CONFIG_TYPES,
	MAVENIR_CONFIG_VERSIONS,
	MAVENIR_CONFIGS,
} from '@constants/queryKeys';

export const useInvalidateDataSources = () => {
	const queryClient = useQueryClient();

	const invalidateDataSources = () => {
		return [
			queryClient.invalidateQueries([MAVENIR_CONFIGS]),
			queryClient.invalidateQueries([CC_VENDORS]),
			queryClient.invalidateQueries([CC_TECHNOLOGIES]),
			queryClient.invalidateQueries([CC_NODE_TYPES]),
			queryClient.invalidateQueries([CC_SITE_IDS]),
			queryClient.invalidateQueries([CC_DATES]),
			queryClient.invalidateQueries([CC_NODES]),
			queryClient.invalidateQueries([CC_RELEASE_VERSIONS]),
			queryClient.invalidateQueries([CC_CONFIG_TYPES]),
			queryClient.invalidateQueries([CC_MAVENIR_DATES]),
			queryClient.invalidateQueries([MAVENIR_CONFIGS]),
			queryClient.invalidateQueries([MAVENIR_CONFIG_GNB_IDS]),
			queryClient.invalidateQueries([MAVENIR_CONFIG_VERSIONS]),
			queryClient.invalidateQueries([MAVENIR_CONFIG_TYPES]),
			queryClient.invalidateQueries([MAVENIR_CONFIG_IDS]),
			queryClient.invalidateQueries([MAVENIR_CONFIG_DATES]),
			queryClient.invalidateQueries([CONSISTENCY_VENDORS]),
			queryClient.invalidateQueries([HISTORY_CHECK_VENDOR]),
		];
	};

	return {
		invalidateDataSources,
	};
};

